import React, { useEffect, useState } from 'react'

import {
  Button,
  Checkbox,
  Container,
  Dialog,
  FormControlLabel,
  Grid,
} from '@material-ui/core'
import axios from 'axios'
import firebase from 'gatsby-plugin-firebase'
import { Link } from 'gatsby-plugin-intl'
import moment from 'moment'
import QRCode from 'qrcode.react'
import { deviceDetect } from 'react-device-detect'
import uuid from 'react-uuid'

import IconAppStore from '~/assets/app_store.svg'
// import IconGooglePlay from '~/assets/google_play.svg'
import IconUpdate from '~/assets/update_icon.svg'
import FacebookFormDialog from '~/components/common/FacebookFormDialog'
import IconGooglePlay from '~/images/google_play.png'
import translate from '~/locale'

import '~/styles/custom/login.scss'

const getToken = () => {
  const device = deviceDetect()
  const token = {
    os: device.osName,
    browser: device.browserName,
    timestamp: moment(),
    uid: uuid(),
  }

  return token
}

export default function Login(props) {
  const [modal, seModal] = useState(props.login)
  const [token, setToken] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [urlToken, setUrlToken] = useState(axios.CancelToken.source())

  const toggle = () => {
    if (!modal) {
      requestRefresh()
    } else {
      urlToken.cancel()
    }
    seModal(!modal)
  }

  const [state, setState] = useState({
    keepSignedIn: false,
  })

  const handleChange = (name) => (event) => {
    setState({ ...state, [name]: event.target.checked })
  }

  const renewToken = () => {
    const newToken = JSON.stringify(getToken())
    setToken(newToken)
    setRefresh(false)
    requestRefresh(newToken)
  }

  const { keepSignedIn } = state

  const requestRefresh = async (addedCurrentToken) => {
    const urlToken = axios.CancelToken.source()
    setRefresh(false)
    setUrlToken(urlToken)

    const currentToken = addedCurrentToken
      ? JSON.parse(addedCurrentToken)
      : JSON.parse(token)

    await axios
      .get(`${process.env.GATSBY_API_URL}?uid=${currentToken.uid}`, {
        cancelToken: urlToken.token,
      })
      .then((response) => {
        location.href = `${process.env.GATSBY_PORTAL_URL}/${response.data.sessionData.language}/dashboard?token=${response.data.sessionData.token}`
      })
      .catch((error) => {
        console.log(error)
        setRefresh(true)
      })
      .then(function () {
        // always executed
      })
  }

  const [facebookFormDialogOpen, setFacebookFormDialogOpen] = useState(false)

  const handleDownloadClick = (store) => {
    firebase.analytics().logEvent('download', {
      store,
    })
    // setFacebookFormDialogOpen(true)
  }

  useEffect(() => {
    setToken(JSON.stringify(getToken()))
  }, [])

  return (
    <>
      <Button
        onClick={toggle}
        className="text-nowrap font-size-xs text-uppercase shadow-second-sm btn-secondary-dark font-weight-500"
      >
        {translate('login')}
      </Button>
      <Dialog
        scroll="body"
        maxWidth="lg"
        open={modal}
        onClose={toggle}
        classes={{
          paper: 'modal-content border-0 bg-white rounded-lg p-3 p-xl-0',
        }}
      >
        <Container maxWidth="md" disableGutters>
          <Grid container spacing={0}>
            <Grid
              item
              md={7}
              className="d-flex pl-sm-5 pr-sm-3 justify-content-center flex-column"
            >
              <div className="mt-5">
                <h2 className="display-4 mb-3 text-primary font-weight-500">
                  {translate('useresionweb')}
                </h2>
                <ul className="list-unstyled mb-0">
                  <li className="mb-3 typography-subtitle1">
                    {translate('openresidentphone')}
                  </li>
                  <li className="mb-3 typography-subtitle1">
                    {translate('tapsettings')}
                  </li>
                  <li className="typography-subtitle1">
                    {translate('pointphone')}
                  </li>
                </ul>
              </div>
              <div className="mt-45">
                {/* <a href="#" className="typography-link">
                  <img className="pr-2" src={IconSupport} />
                  Need help to get started?
                </a> */}
              </div>
              <div className="mt-45 typography-body2">
                {translate('dont_have_facebook')}
                <br />
              </div>
              <div className="mb-5">
                <a
                  className="link-download"
                  href="https://play.google.com/store/apps/details?id=io.baseline.resident"
                  target="_blank"
                  rel="noreferrer"
                  // onClick={() => handleDownloadClick('google')}
                >
                  <img src={IconGooglePlay} className="google" />
                </a>
                <a
                  className="link-download"
                  href="https://apps.apple.com/us/app/resident/id1547782698"
                  target="_blank"
                  rel="noreferrer"
                  // onClick={() => handleDownloadClick('apple')}
                >
                  <IconAppStore className="appstore" />
                </a>
                <FacebookFormDialog
                  open={facebookFormDialogOpen}
                  onClose={() => setFacebookFormDialogOpen(false)}
                />
              </div>
            </Grid>
            <Grid
              item
              md={5}
              className="d-flex py-5 pr-sm-5 align-items-center flex-column"
            >
              <div className="position-relative">
                {refresh && (
                  <div
                    className="bg-white-500 w-100 position-absolute d-flex justify-content-center align-items-center"
                    style={{ height: '220px' }}
                  >
                    <Button
                      onClick={() => renewToken()}
                      className="bg-primary rounded-circle"
                      style={{ height: '180px', width: '180px' }}
                    >
                      <div className="d-flex flex-column justify-content-center align-items-center">
                        <IconUpdate style={{ color: '#FFFFFF' }} />
                        <span className="text-white font-weight font-size-sm mt-2">
                          CLICK TO RELOAD QR CODE
                        </span>
                      </div>
                    </Button>
                  </div>
                )}
                {token && (
                  <QRCode
                    value={token}
                    size={220}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}
                    level={'L'}
                    includeMargin={false}
                    renderAs={'svg'}
                    imageSettings={{
                      src: '../../../qr_code.svg',
                      x: null,
                      y: null,
                      height: 40,
                      width: 40,
                      excavate: true,
                    }}
                  />
                )}
                {/* <div className="mt-4">
                  <FormControlLabel
                    classes={{
                      label: 'typography-link',
                    }}
                    control={
                      <Checkbox
                        checked={keepSignedIn}
                        onChange={handleChange('keepSignedIn')}
                        value="keepSignedIn"
                      />
                    }
                    label={translate('keep_signed_in')}
                  />
                </div> */}

                <div className="mt-4 text-center">
                  <span className="typography-body2">
                    {translate('by_continuing_you_agree')}
                    <br />
                    <Link to="/legal" className="text-primary">
                      {translate('support_termsofuse')}
                    </Link>
                  </span>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Dialog>
    </>
  )
}
